import { entity } from "./Connection"

export const AuditLogEditEntity = entity("AuditLogEdit");
